import { useLocation } from '@tanstack/react-router';
import { getPodV2ExitUrl } from '@/shared/utils/pod-v2';
import { PodV2CommandBar } from './pod-v2-command-bar';

const noop = () => {};

/** 화면 청크를 기다리는 동안에도 완성 화면과 같은 헤더와 높이를 유지합니다. */
export const PodV2PendingPage = () => {
    const { search } = useLocation();

    return (
        <section className="pod-v2-page" aria-busy="true">
            <PodV2CommandBar
                articleOptions={[]}
                dan={1}
                disabled
                exitUrl={getPodV2ExitUrl(search.returnTo)}
                includeAnswer
                includeExplanation
                includeTranslation
                isEnglishSubject={false}
                onAnswerChange={noop}
                onDanChange={noop}
                onDownload={noop}
                onExplanationChange={noop}
                onTranslationChange={noop}
                onSelectSet={noop}
                onSheetChange={noop}
                selectedSetId=""
                setIds={[]}
                setTitles={[]}
                sheet="question"
                showDanControls={false}
                status="POD를 준비하는 중입니다."
                title="자료를 불러오는 중입니다."
            />
            <div className="pod-v2-viewer-stage">
                <div className="pod-v2-viewer-stage__status" role="status">
                    POD를 준비하는 중입니다.
                </div>
            </div>
        </section>
    );
};
